import type { EditorServiceModels } from '@editor/client-rest-api';
import getStore from '../store/store';
import { ObservableMap } from 'mobx';

export default function getAllOverriddenOptions(): ObservableMap<
    string,
    EditorServiceModels.CritiqueTypeOption
> {
    const store = getStore();
    const { defaultOptionsEditor, userOptions } = store;
    const { overriddenOptions, overriddenCategories } = userOptions;

    const mergedCritiques = new ObservableMap<string, EditorServiceModels.CritiqueTypeOption>();

    // First copy over all of the individually overridden options to the merged set
    overriddenOptions?.forEach((value, key) => {
        mergedCritiques.set(key, value);
    });

    // Now, we want to go through whole categories that are disabled and set all of the individual overridden options
    // in each of the disabled categories to disabled.
    // To do this, go through all of the default options and check to see if the category for that option is
    // disabled. If the category is disabled, then we need to set the option to disabled
    defaultOptionsEditor.forEach((value, key) => {
        if (
            overriddenCategories?.has(value.categoryId) &&
            overriddenCategories?.get(value.categoryId) === false
        ) {
            // The category for this option is disabled, so disable the option and add it to the map
            const updatedCritiqueTypeOption: EditorServiceModels.CritiqueTypeOption = {
                id: key,
                value: '0',
            };
            mergedCritiques.set(key, updatedCritiqueTypeOption);
        }
    });

    return mergedCritiques;
}
